<footer class="text-center text-lg-start bg-body-tertiary pepsico-footer pt-3">
  <section class="">
    <div class="container text-center text-md-start mt-5">
      <div class="row mt-3">

        <div class="col-lg-8 col-xl-8 mb-4 appfotter-pepsico">

          <div class="row">
            <div class="col-md-3">
              <h6 class="fw-bold mtop-sm">
                Mapa de sitio
              </h6>
              <a routerLink="home" class="fnt-footer-lex">Home</a>
              <a routerLink="privacy" class="fnt-footer-lex">Aviso de Privacidad</a>
              <a routerLink="base" class="fnt-footer-lex">Bases</a>
            </div>
            <div class="col-md-3">
              <h6 class="text-uppercase fw-bold ">
                &nbsp;
              </h6>
              <a routerLink="my-orders" class="fnt-footer-lex" *appShowFeature="Feature.MyOrders">Seguimientos de
                pedido</a>
              <a href="#" class="fnt-footer-lex">Reportar inconveniente</a>
              <a routerLink="rewards" class="fnt-footer-lex">Catálogo de premios</a>
            </div>
            <div class="col-md-3">
              <h6 class="text-uppercase fw-bold ">
                &nbsp;
              </h6>
              <a routerLink="how-do-i-win" class="fnt-footer-lex">Cómo gano</a>
            </div>
            <div class="col-md-3">
              <h6 class="text-uppercase fw-bold ">
                &nbsp;
              </h6>
              <a routerLink="my-points" class="fnt-footer-lex">Mis puntos</a>
              <a routerLink="profile" class="fnt-footer-lex">Mi cuenta</a>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-4 mb-4 appfotter-pepsico">
          <h6 class="text-uppercase fw-bold ">
            Descarga la APP
          </h6>
          <p class="fnt-footer-lex">
            Disfrutar de nuestros beneficios que tenemos para ti.
          </p>
          <div class="d-flex justify-content-center">
            <a href="https://www.apple.com/mx/app-store/" target="_blank" class="no-decoration">
              <img src="./assets/images/footer-logo-app1.png" alt="" class="store-app jump-shake">
            </a>
            <a href="https://play.google.com/store/games?hl=es_MX" target="_blank" class="no-decoration">
              <img src="./assets/images/footer-logo-app2.png" alt="" class="store-app jump-shake">
            </a>
          </div>
        </div>



      </div>
    </div>
  </section>
  <div class="text-center back-footer-foo">
    <a href="#!" class="legales-2-footer">Aviso de privacidad</a> / <a href="#!" class="legales-2-footer">Legales</a>
    / Carrera a la Excelencia® 2025 Todos los derechos reservados, operado por Master Loyalty Group.
  </div>
</footer>